import { AlarmAction } from '../alarm-action';
import { parseNumber } from '../../utils/number.utils';
import { isArray } from 'util';

export class AlarmActionBuilder {
  static fromJson(json) {
    return (json)
      ? new AlarmAction(
        parseNumber(json.code),
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(AlarmActionBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/alarm-action.builder.ts